<template>
  <router-link to="/">
    <img src="/img/logo.png" alt="" />
  </router-link>
</template>
